export interface LanguageOption {
  key: string;
  label: string;
}

export interface SkillOption {
  key: string;
  label: string;
}

export const LANGUAGE_OPTIONS: LanguageOption[] = [
  { key: 'CANTONESE', label: 'Cantonese' },
  { key: 'ENGLISH', label: 'English' },
  { key: 'MANDARIN', label: 'Mandarin' },
  { key: 'TAGALOG', label: 'Tagalog' },
  { key: 'INDONESIAN', label: 'Indonesian' },
  { key: 'THAI', label: 'Thai' },
  { key: 'HINDI', label: 'Hindi' },
  { key: 'FRENCH', label: 'French' },
  { key: 'JAPANESE', label: 'Japanese' },
  { key: 'KOREAN', label: 'Korean' },
  { key: 'OTHER', label: 'Other' },
];

export const SKILL_OPTIONS: SkillOption[] = [
  { key: 'CLEANING', label: 'Cleaning' },
  { key: 'ELDERLY_CARE', label: 'Elderly Care' },
  { key: 'CHILD_CARE', label: 'Child Care' },
  { key: 'INFANT_CARE', label: 'Infant Care' },
  { key: 'NURSING', label: 'Nursing' },
  { key: 'DRIVING', label: 'Driving' },
  { key: 'LAUNDRY', label: 'Laundry' },
  { key: 'IRONING', label: 'Ironing' },
  { key: 'SHOPPING', label: 'Shopping' },
  { key: 'HOUSEKEEPING', label: 'Housekeeping' },
  { key: 'ORGANIZING', label: 'Organizing' },
  { key: 'PET_CARE', label: 'Pet Care' },
  { key: 'GARDENING', label: 'Gardening' },
];


export const getRestDayOptions = (t: (key: string, fallback: string) => string) => [
  { value: 'WEEKDAY', label: t('jobDetail.weekday', '平日') },
  { value: 'SATURDAY', label: t('jobDetail.saturday', '星期六') },
  { value: 'SUNDAY', label: t('jobDetail.sunday', '星期日') },
  { value: 'TO_BE_DISCUSS', label: t('jobForm.salaryNegotiable', '面議') },
  { value: 'ANY', label: t('jobForm.any', '不限') },
];

export const getAccommodationOptions = (t: (key: string, fallback: string) => string) => [
  { value: 'SEPARATE_ROOM', label: t('helperProfileForm.accommodateSeparate', '獨立房間') },
  { value: 'SHARED_ROOM', label: t('helperProfileForm.accommodateShared', '共用房間') },
  { value: 'LIVE_OUT', label: t('helperProfileForm.accommodateLiveOut', '外宿') },
];

